
import { Vue, Component } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import {
  ApplicationDto,
  getApplication,
  getApplicationByParent,
  getAdvertisementList,
  bannerDto,
  getActualByDate
} from '@/api/homes'
import { getUserOtherInfoFCD } from '@/api/commonConfig'
import JumpWarn from '@/views/financial/JumpWarn.vue'
import BannerSwiper from '@/views/homes/BannerSwiper.vue'
import { getPreCredit, getPreCreditUrl } from '@/api/preCredit'
import { getFinanceAuthority, getAvoidLoginUrl, getWhiteSign } from "@/api/iousServices"
import { openNewPage, openFDWhitePage, setSessionItem } from '@/utils/h5ToApp'
import dayjs from "dayjs"
import whitePayPopup from '@/components/whitePayPopup/index.vue'
@Component({
  components: {
    JumpWarn,
    BannerSwiper,
    whitePayPopup
  }
})
export default class Home extends Vue {
  @Getter userId!: string
  @Getter info: any // 用户信息
  @Getter companyName: string // 公司名称
  @Getter logoUrl: string // 公司头像
  @Getter companyId: string // 公司id
  @Getter whiteStrips!: number
  @Getter mobile!: string
  @Action setWhiteStrips!: (val: string) => void
  @Action setRootPath!: (val: string) => void;

  refreshing = false
  urlLink = ''
  whiteSignTime = ''
  endSignTime = ''

  overview = {
    // 实时概况
    currentMoney: 0, //金额-今天
    currentNumber: 0, //订单数-今天
    currentMerchants: 0, //客户数-今天
    yesterdayMoney: 0, //金额-昨天
    yesterdayNumber: 0, //订单数-昨天
    yesterdayMerchants: 0 //客户数-昨天
  }

  // 常用应用
  favoriteList: ApplicationDto[] = []
  // 后端返回的所有的应用(用于匹配常用应用和热门应用)
  allApp: ApplicationDto[] = []

  translationsHotApp: ApplicationDto[] = []
  banners: bannerDto[] = []

  show = false
  canPreCredit = false
  msg1 = ''
  msg2 = ''

  created () {
    // 清楚飞贷白条缓存数据
    window.localStorage.removeItem('FDWhite')
    // 清除回退地址，防止缓存导致跳转异常
    setSessionItem('cykjSource', '')
    this.init()
    this.openPopup()
  }

  onRefresh () {
    this.init()
  }

  init () {
    this.getFavoriteList()
    this.getActualByDate()
    this.getAdvertisementList()
    this.getApplicationByParent()
    this.getWhiteStrips()
    this.getSign()
  }

  /**
   * @description 首页弹出签约华润弹框
   */
  openPopup() {
    let params = { companyId: this.companyId, mobile: this.mobile }
    setTimeout(() => {
      this.$resultPopup.show({...params})
    }, 500);
    
  }

  /**
  * @description: 获取预授信免登陆接口
  * @param {*} null
  * @return {*} null
  */
  handleConfirm() {
    console.log('userType',this.info.userType);
    let type = this.info.userType
    let params:any = {
      userId:this.userId
    }
    if(type === '2') {
      params = {
        userId2:this.userId
      }
    }
    if(!this.canPreCredit) return 
    getPreCreditUrl(params).then(res => {
        console.log('getPreCreditUrl',res);
        openNewPage({url: encodeURI(res.data.redirectUrl)})
    })
  }

  /**
   * 获取实时概况
   */
  getActualByDate () {
    getActualByDate({})
        .then((res) => {
          this.overview = res.data
        })
        .finally(() => {
          this.refreshing = false
        })
  }

  getHtml(html:string){
    return html
  }

  /**
   * 获取常用应用数据
   */
  getFavoriteList () {
    let parmas = {
      partnerCompanyId: this.info.partnerCompanyId || 'system',
      scope: '1' // 查询来源
    }
    getApplication(parmas)
        .then((res) => {
          this.favoriteList = res.data.favoriteList
          this.allApp = res.data.allList
          this.favoriteList.map((item) => {
            this.allApp.filter((data) => {
              if (data.applicationId === item.applicationId) {
                item.route = data.route
                item.applicationLogo = data.applicationLogo
                item.applicationName = data.applicationName
              }
            })
            item = this._handleAction(item)
          })
        })
        .finally(() => {
          this.refreshing = false
        })
  }

  /**
   *  应用数据绑定权限
   */
  _handleAction (app: ApplicationDto) {
    app.action = app.route.substring(1, app.route.length)
    return app
  }

  /**
   * 获取banner图
   */
  getAdvertisementList () {
    let parma = {
      partnerCompanyId: this.info.partnerCompanyId || 'system',
      deliverArea: '1' // 1 首页 2 资讯页
    }
    getAdvertisementList(parma)
        .then((res) => {
          this.banners = res.data.advertisementList
        })
        .finally(() => {
          this.refreshing = false
        })
  }

  /**
   * 获取热门应用数据
   */
  getApplicationByParent () {
    let parmas = {
      partnerCompanyId: this.info.partnerCompanyId || 'system',
      parentId: 'applyClassify005',
      pageIndex: 1,
      pageSize: 99 // 不太理解为什么接口要求传入分页参数
    }
    getApplicationByParent(parmas)
        .then((res) => {
          this.translationsHotApp = res.data.allList
          this.translationsHotApp.map((item) => {
            item = this._handleAction(item)
          })
          // 飞贷白条需求 只首页隐藏旧金融入口，其他入口不隐藏，可通过applicationName | route判断
          this.translationsHotApp = this.translationsHotApp.filter(item => {
            return item.applicationName !== '旧金融'
          })
        })
        .finally(() => {
          this.refreshing = false
        })
  }

  /**
   * 获取金融权限
   */
  getWhiteStrips() {
    getFinanceAuthority({companyId: this.companyId}).then((res) =>{
      const { code, data } = res
      if( code === "000000" ) {
        this.setWhiteStrips(data.whiteStrips)
      }
      console.log('homeAuthority=',res);
    })
  }

  getAuthority() {
    switch (this.whiteStrips) {
      case 2:
        this.$dialog
          .confirm({
            message: "开通金融服务需完成企业认证",
            confirmButtonText: "去认证",
            cancelButtonText: "取消认证",
          })
          .then(() => {
            // 白条需求支付标识，用于人脸识别使用
            window.localStorage.setItem('FDWhite','1')
            window.localStorage.setItem('isFinance','1')
            this.$router.push({
              path: "/companyInfoForm",
              query: {
                formPage: "h5",
              },
            });
          })
          .catch(() => {});
        break;
      case 3:
        this.$dialog
          .confirm({
            message: "开通金融服务需完成个人身份认证，且身份为持股比例大于5%的股东",
            confirmButtonText: "去认证",
            cancelButtonText: "取消认证",
          })
          .then(() => {
            // 白条需求支付标识，用于人脸识别使用
            window.localStorage.setItem('FDWhite','1')
            window.localStorage.setItem('isFinance','1')
            this.$router.push({
              path: "/userInfoForm",
              query: {
                formPage: "h5",
              },
            });
          })
          .catch(() => {});
        break;
      case 5:
        this.$dialog
          .confirm({
            message: "当前账号不符合金融服务开通条件，需企业法人或持股比例大于5%股东才可开通，若您身份已变更，可前往身份认证进行修改",
            confirmButtonText: "去认证",
            cancelButtonText: "取消认证",
          })
          .then(() => {
            this.$router.push({
              path: "/userInfoForm",
              query: {
                formPage: "h5",
              },
            });
          })
          .catch(() => {});
        break;
      case 1:
      case 4:
        // 是否签署授权书
        if (window.localStorage.getItem('isSign') == '1' && this.whiteSignTime < this.endSignTime) {
          this.fdfreeLogin()
        } else {
          window.localStorage.removeItem('isSign')
          this.$router.push({
            path: "/iousAuthorize",
            query: {
              cykjSource: 'homes'
            }
          })
        }
        break;
    }
  }
  /**
   * 跳转到搜索页
   */
  toSearch () {
    this.$router.push({
      path: '/searchHomes'
    })
  }

  /**
   * 常用应用跳转到应用内部
   */
  goApp (app: ApplicationDto) {
    if (!this.$isAction(app.action) && app.action !== 'preVerifyPhone') {
      this.$toast('暂无此操作权限，请联系管理员')
      return false
    }
    this.setRootPath('/homes')
    if (app.applicationName === '金融服务') { 
      this.getAuthority()
      return false
    }
    if (app.route === '/financialServices') {
      this._getInfoFCD()
      return false
    }
    if (app.route === '/valetOrder') {
      this.$router.push({path: app.route, query: {fromPath: '3'}})
      return false
    }
    if(app.route === '/preVerifyPhone') {
        console.log('userType',this.info.userType);
        let type = this.info.userType
        let params:any = {
          userId:this.userId
        }
        if(type === '2') {
          params = {
            userId2:this.userId
          }
        }
        this.msg1 = ''
        this.msg2 = ''
        this.show = true
        getPreCredit(params).then((res) => {
          console.log('getPreCredit', res)
          if (res.code === '000000') {
            this.canPreCredit = true
          } else if (res.code === '000002') {
            this.canPreCredit = false
          }
          this.msg1 = res.data.msg
          this.msg2 = res.data.msg2
        })
        return false
    }
    this.$router.push({
      path: app.route
    })
  }

  /**
   * 判断用户金融服务授信是否已过期
   */
  _getInfoFCD () {
    getUserOtherInfoFCD({userId: this.userId}).then((res) => {
      if (res.code === '000000' && res.data.isExpire !== true) {
        //    跳转到金融服务页面
        this.$router.push({
          path: '/financialServices'
        })
      } else {
        // 进入授信流程
        ;(this.$refs.jumpWarn as any).showModal()
      }
    })
  }

  // 1还款入口 2授信入口 3借款入口 
  fdfreeLogin(flag = '') {
    let params = {
      companyId: this.companyId,
      webShow: flag
    }
    getAvoidLoginUrl({...params}).then((res) =>{
      const { code, data } = res
      if( code === "000000" ) {
        let encodeUrl = encodeURI(data.responseData.redirectUrl)
        let isQuery = encodeUrl.indexOf('?') > -1
        let url = `${encodeUrl}${isQuery? '&' : '?'}webShow=${flag}&userPhone=${this.mobile}&cykjSource=homes` // + (flag == '' ? `&companyName=${this.companyName}` : '')
        // openNewPage({url})
        // window.location.href = url
        openFDWhitePage({url})
        console.log('getAvoidLoginUrl=',url);
      }
    }).catch(() => {
      this.$toast('此产业商城暂未开通白条快付')
    })
  }

  // 获取授权书记录
  getSign() {
    getWhiteSign().then((res =>{
      const { code, data } = res
      if( code === "000000" && data) {
        let firstSignTime = data.whiteSignTime
        firstSignTime = dayjs(firstSignTime).format("YYYY-MM-DD")  
        this.endSignTime = dayjs(firstSignTime).add(360, 'day').format("YYYY-MM-DD");
        this.whiteSignTime = dayjs().format("YYYY-MM-DD");
        console.log('首次签署日期=======',firstSignTime);
        console.log('再次签署日期=======',this.endSignTime);
        if (this.whiteSignTime < this.endSignTime) window.localStorage.setItem('isSign','1')
      }
    }))
  }
}
